if (!window.Eurus.loadedScript.includes('preview-color-swatches.js')) {
  window.Eurus.loadedScript.push('preview-color-swatches.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCard', (
        sectionId,
        productUrl,
        productId,
      ) => ({
        currentVariant: '',
        isSelect: false,
        productId: productId,
        showOptions: false,
        init() {
          document.addEventListener(`eurus:product-card-variant-select:updated:${sectionId}`, (e) => {
            this.currentVariant = e.detail.currentVariant,
            this.options = e.detail.options;
            this.checkVariantSelected();
            if (this.currentVariant && this.currentVariant.id) {
              let featured_image = ""
              if (this.currentVariant.featured_image != null) {
                featured_image = this.currentVariant.featured_image.src;
              }
              Alpine.store('xPreviewColorSwatch').updateImage(this.$el, productUrl, featured_image, this.currentVariant.id)
            }
          });
        },
        checkVariantSelected() {
          const fieldset = [...document.querySelectorAll(`#variant-update-${sectionId} fieldset`)];
          if(fieldset.findIndex(item => !item.querySelector("input:checked")) == "-1") {
            this.isSelect = true;
          }
        }
      }))

      Alpine.store('xPreviewColorSwatch', {
        updateImage(el, productUrl, src, variantId) {
          const cardProduct = el.closest('.card-product');
          let getLink =  productUrl + `?variant=${variantId}`;

          if (!cardProduct) return;
          const linkVariant = cardProduct.getElementsByClassName("link-product-variant");
          for (var i = 0; i < linkVariant.length; i ++) {
            linkVariant[i].setAttribute("href", getLink);
          }

          if (src != '') {
            const previewImg = cardProduct.getElementsByClassName("preview-img")[0];
            if (!previewImg) return;
            previewImg.removeAttribute("srcset");
            previewImg.setAttribute("src", src);
          }

          const currentVariant = cardProduct.querySelector(".current-variant");
          if (currentVariant) {
            currentVariant.innerText = variantId;
          }
        }
      });
    })
  });
}    